"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5537],{

/***/ 95537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QT": function() { return /* binding */ getOnsenAreaObject; },
/* harmony export */   "Ur": function() { return /* binding */ getTranslatedOnsenAreaName; },
/* harmony export */   "VO": function() { return /* binding */ getOnsensExtraInfoWithFilter; },
/* harmony export */   "Yz": function() { return /* binding */ getOnsenAreaLinkBySlug; },
/* harmony export */   "tC": function() { return /* binding */ getOnsenAreaDetailBySlug; },
/* harmony export */   "wI": function() { return /* binding */ getOnsenAreaLinksBySlugs; }
/* harmony export */ });
/* unused harmony exports AREA_SLUGS, POPULAR_AREA_SLUGS, AREA_COUNT, getOnsenAreaYadoListLinks, getOnsenPopularAreaDetailLinks, getOnsenAreaThumbnail, getOnsenAreaCoverPhoto */
/* harmony import */ var _tmp_build_c0c8f40b_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90116);
/* harmony import */ var _legacy_shared_utils_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46680);
/* harmony import */ var _R__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9574);
/* harmony import */ var _constants_ENV__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18899);
/* harmony import */ var _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26945);
/* harmony import */ var _models_trackings_SentryReporter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70893);
/* harmony import */ var _shared_utils_url_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96183);







// 直接使用禁止。getOnsenAreaObjectを使用すること
var onsenAreaObjects = {
  wamazing: {
    englishName: 'WAMAZING',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHanamaki */ .Z.i18n.webYadoAirportHanamaki(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai()];
    },
    coordinates: {
      lat: 35.72,
      lng: 135.72
    },
    mediaArticleIds: ['a-189']
  },
  hanamaki: {
    englishName: 'HANAMAKI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'iwate',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureIwate */ .Z.i18n.webYadoPrefectureIwate()
      }];
    },
    coordinates: {
      lat: 39.45105,
      lng: 141.068222
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHanamaki */ .Z.i18n.webYadoAirportHanamaki(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai()];
    },
    mediaArticleIds: ['a-634', 'a-444', 'a-189', 'a-1180']
  },
  'hakone-yugawara': {
    englishName: 'HAKONE',
    pjtRegion: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.kantoShortName */ .Z.i18n.kantoShortName,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kanagawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKanagawa */ .Z.i18n.webYadoPrefectureKanagawa()
      }];
    },
    coordinates: {
      lat: 35.2323737,
      lng: 138.9775716
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    mediaArticleIds: ['a-1127', 'a-192', 'a-1180', 'a-1133', 'a-366'],
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaHakoneYugawara */ .Z.assets.images.pjtAreaHakoneYugawara
  },
  yugawara: {
    englishName: 'YUGAWARA',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtYugawara */ .Z.i18n.pjtYugawara,
    pjtRegion: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.kantoShortName */ .Z.i18n.kantoShortName,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kanagawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKanagawa */ .Z.i18n.webYadoPrefectureKanagawa()
      }];
    },
    coordinates: {
      lat: 35.2323737,
      lng: 138.9775716
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    mediaArticleIds: ['a-1127', 'a-192', 'a-1180', 'a-1133', 'a-366'],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtYugawaraAccess */ .Z.i18n.pjtYugawaraAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaYugawara */ .Z.assets.images.pjtAreaYugawara
  },
  'nikko-kinugawa': {
    englishName: 'NIKKO-KINUGAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'tochigi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureTochigi */ .Z.i18n.webYadoPrefectureTochigi()
      }];
    },
    coordinates: {
      lat: 36.846639,
      lng: 139.4501483
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    mediaArticleIds: ['a-194', 'a-193', 'a-1128', 'a-445', 'a-998'],
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaNikkoKinugawa */ .Z.assets.images.pjtAreaNikkoKinugawa
  },
  beppu: {
    englishName: 'BEPPU',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtBeppu */ .Z.i18n.pjtBeppu,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'oita',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOita */ .Z.i18n.webYadoPrefectureOita()
      }];
    },
    coordinates: {
      lat: 33.279382,
      lng: 131.5047527
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKitakyushu */ .Z.i18n.webYadoAirportKitakyushu()];
    },
    mediaArticleIds: ['a-325', 'a-941', 'a-450', 'a-1061'],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtBeppuAccess */ .Z.i18n.pjtBeppuAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaBeppu */ .Z.assets.images.pjtAreaBeppu
  },
  arima: {
    englishName: 'ARIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hyogo',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHyogo */ .Z.i18n.webYadoPrefectureHyogo()
      }];
    },
    coordinates: {
      lat: 34.7992575,
      lng: 135.2441083
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOsakaKokusai */ .Z.i18n.webYadoAirportOsakaKokusai()];
    },
    mediaArticleIds: ['a-161', 'a-613', 'a-443'],
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaArima */ .Z.assets.images.pjtAreaArima
  },
  misasa: {
    englishName: 'MISASA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'tottori',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureTottori */ .Z.i18n.webYadoPrefectureTottori()
      }];
    },
    coordinates: {
      lat: 35.4102822,
      lng: 133.8905891
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTottori */ .Z.i18n.webYadoAirportTottori(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYonago */ .Z.i18n.webYadoAirportYonago()];
    },
    mediaArticleIds: ['a-324', 'a-448', 'a-633']
  },
  kinosaki: {
    englishName: 'KINOSAKI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hyogo',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHyogo */ .Z.i18n.webYadoPrefectureHyogo()
      }];
    },
    coordinates: {
      lat: 35.623761,
      lng: 134.8114823
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTajima */ .Z.i18n.webYadoAirportTajima()];
    },
    mediaArticleIds: ['a-162', 'a-447', 'a-622'],
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaKinosaki */ .Z.assets.images.pjtAreaKinosaki
  },
  shodoshima: {
    englishName: 'SHODOSHIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kagawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKagawa */ .Z.i18n.webYadoPrefectureKagawa()
      }];
    },
    coordinates: {
      lat: 34.4884697,
      lng: 134.1694087
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTakamatsu */ .Z.i18n.webYadoAirportTakamatsu()];
    },
    mediaArticleIds: ['a-174', 'a-452', 'a-952']
  },
  tendo: {
    englishName: 'TENDO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamagata',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamagata */ .Z.i18n.webYadoPrefectureYamagata()
      }];
    },
    coordinates: {
      lat: 38.3581421,
      lng: 140.3738465
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYamagata */ .Z.i18n.webYadoAirportYamagata(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai()];
    },
    mediaArticleIds: ['a-188', 'a-453', 'a-968']
  },
  dogo: {
    englishName: 'DOGO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'ehime',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureEhime */ .Z.i18n.webYadoPrefectureEhime()
      }];
    },
    coordinates: {
      lat: 33.834098,
      lng: 132.7756944
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportMatsuyama */ .Z.i18n.webYadoAirportMatsuyama(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTakamatsu */ .Z.i18n.webYadoAirportTakamatsu()];
    },
    mediaArticleIds: ['a-164', 'a-449', 'a-625', 'a-1648']
  },
  yufuin: {
    englishName: 'YUFUIN',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtYufuin */ .Z.i18n.pjtYufuin,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'oita',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOita */ .Z.i18n.webYadoPrefectureOita()
      }];
    },
    coordinates: {
      lat: 33.2755344,
      lng: 131.3235478
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKitakyushu */ .Z.i18n.webYadoAirportKitakyushu()];
    },
    mediaArticleIds: ['a-326', 'a-353', 'a-942', 'a-1137', 'a-1062'],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtYufuinAccess */ .Z.i18n.pjtYufuinAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaYufuin */ .Z.assets.images.pjtAreaYufuin
  },
  kurokawa: {
    englishName: 'KUROKAWA',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtKurokawa */ .Z.i18n.pjtKurokawa,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kumamoto',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKumamoto */ .Z.i18n.webYadoPrefectureKumamoto()
      }];
    },
    coordinates: {
      lat: 33.0781444,
      lng: 131.1312534
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKagoshima */ .Z.i18n.webYadoAirportKagoshima(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKumamoto */ .Z.i18n.webYadoAirportKumamoto()];
    },
    mediaArticleIds: ['a-327', 'a-1132'],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtKurokawaAccess */ .Z.i18n.pjtKurokawaAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaKurokawa */ .Z.assets.images.pjtAreaKurokawa
  },
  izu: {
    englishName: 'IZU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shizuoka',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShizuoka */ .Z.i18n.webYadoPrefectureShizuoka()
      }];
    },
    coordinates: {
      lat: 34.9215135,
      lng: 138.7697863
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShizuoka */ .Z.i18n.webYadoAirportShizuoka()];
    },
    mediaArticleIds: ['a-200', 'a-367'],
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaIzu */ .Z.assets.images.pjtAreaIzu
  },
  zao: {
    englishName: 'ZAO KAMINOYAMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamagata',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamagata */ .Z.i18n.webYadoPrefectureYamagata()
      }];
    },
    coordinates: {
      lat: 38.1641663,
      lng: 140.3744106
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYamagata */ .Z.i18n.webYadoAirportYamagata()];
    },
    mediaArticleIds: ['a-187']
  },
  akiu: {
    englishName: 'AKIU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'miyagi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureMiyagi */ .Z.i18n.webYadoPrefectureMiyagi()
      }];
    },
    coordinates: {
      lat: 38.2292707,
      lng: 140.7182746
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai()];
    },
    mediaArticleIds: ['a-191', 'a-1163']
  },
  shiretoko: {
    englishName: 'SHIRETOKO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    coordinates: {
      lat: 44.0690768,
      lng: 144.9884739
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportAsahikawa */ .Z.i18n.webYadoAirportAsahikawa()];
    },
    mediaArticleIds: ['a-459', 'a-989', 'a-1170']
  },
  echigoyuzawa: {
    englishName: 'ECHIGOYUZAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'niigata',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNigata */ .Z.i18n.webYadoPrefectureNigata()
      }];
    },
    coordinates: {
      lat: 36.8505343,
      lng: 138.730411
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNigata */ .Z.i18n.webYadoAirportNigata()];
    },
    mediaArticleIds: ['a-1169']
  },
  nankishirahama: {
    englishName: 'NANKISHIRAHAMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'wakayama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureWakayama */ .Z.i18n.webYadoPrefectureWakayama()
      }];
    },
    coordinates: {
      lat: 33.6757624,
      lng: 135.3848393
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNankiShirahama */ .Z.i18n.webYadoAirportNankiShirahama()];
    },
    mediaArticleIds: ['a-165', 'a-943', 'a-1632']
  },
  yuda: {
    englishName: 'YUDA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamaguchi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamaguchi */ .Z.i18n.webYadoPrefectureYamaguchi()
      }];
    },
    coordinates: {
      lat: 34.1657572,
      lng: 131.4516648
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHiroshima */ .Z.i18n.webYadoAirportHiroshima(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYamaguchiUbe */ .Z.i18n.webYadoAirportYamaguchiUbe()];
    },
    mediaArticleIds: ['a-369', 'a-1164']
  },
  kusatsu: {
    englishName: 'KUSATSU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gunma',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGunma */ .Z.i18n.webYadoPrefectureGunma()
      }];
    },
    coordinates: {
      lat: 36.6228396,
      lng: 138.5945169
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    mediaArticleIds: ['a-195', 'a-1129', 'a-1219'],
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaKusatsu */ .Z.assets.images.pjtAreaKusatsu
  },
  ikaho: {
    englishName: 'IKAHO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gunma',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGunma */ .Z.i18n.webYadoPrefectureGunma()
      }];
    },
    coordinates: {
      lat: 36.5004451,
      lng: 138.9261452
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    mediaArticleIds: ['a-196', 'a-1130']
  },
  fuji: {
    englishName: 'FUJI KAWAGUCHIKO',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtFuji */ .Z.i18n.pjtFuji,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shizuoka',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShizuoka */ .Z.i18n.webYadoPrefectureShizuoka()
      }, {
        prefectureId: 'yamanashi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamanashi */ .Z.i18n.webYadoPrefectureYamanashi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShizuoka */ .Z.i18n.webYadoAirportShizuoka()];
    },
    coordinates: {
      lat: 35.3606255,
      lng: 138.7273634
    },
    mediaArticleIds: ['a-465', 'a-1135', 'a-1675'],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtFujiAccess */ .Z.i18n.pjtFujiAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaFuji */ .Z.assets.images.pjtAreaFuji
  },
  aizu: {
    englishName: 'HIGASHIYAMA-AIZU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'fukushima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureFukushima */ .Z.i18n.webYadoPrefectureFukushima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 37.4899827,
      lng: 139.9277486
    },
    mediaArticleIds: ['a-1168', 'a-1167', 'a-1166']
  },
  atami: {
    englishName: 'ATAMI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shizuoka',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShizuoka */ .Z.i18n.webYadoPrefectureShizuoka()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 35.1038422,
      lng: 139.0778841
    },
    mediaArticleIds: ['a-971', 'a-197']
  },
  ogoto: {
    englishName: 'OGOTO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shiga',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShiga */ .Z.i18n.webYadoPrefectureShiga()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOsakaKokusai */ .Z.i18n.webYadoAirportOsakaKokusai()];
    },
    coordinates: {
      lat: 35.0977907,
      lng: 135.8952886
    },
    mediaArticleIds: ['a-172', 'a-950']
  },
  'hida-takayama': {
    englishName: 'HIDA-TAKAYAMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gifu',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGifu */ .Z.i18n.webYadoPrefectureGifu()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportToyama */ .Z.i18n.webYadoAirportToyama()];
    },
    coordinates: {
      lat: 36.1461317,
      lng: 137.252159
    },
    mediaArticleIds: ['a-199']
  },
  kotohira: {
    englishName: 'KOTOHIRA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kagawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKagawa */ .Z.i18n.webYadoPrefectureKagawa()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTakamatsu */ .Z.i18n.webYadoAirportTakamatsu()];
    },
    coordinates: {
      lat: 34.1914394,
      lng: 133.823306
    },
    mediaArticleIds: ['a-171', 'a-949']
  },
  'nagatoyumoto-yuyawan': {
    englishName: 'NAGATOYUMOTO-YUYAWAN',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamaguchi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamaguchi */ .Z.i18n.webYadoPrefectureYamaguchi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHiroshima */ .Z.i18n.webYadoAirportHiroshima(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 34.3286746,
      lng: 131.1721005
    },
    mediaArticleIds: []
  },
  'oboke-iya': {
    englishName: 'OBOKE-IYA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'tokushima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureTokushima */ .Z.i18n.webYadoPrefectureTokushima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTokushima */ .Z.i18n.webYadoAirportTokushima(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTakamatsu */ .Z.i18n.webYadoAirportTakamatsu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKochi */ .Z.i18n.webYadoAirportKochi()];
    },
    coordinates: {
      lat: 33.8848504,
      lng: 133.7605839
    },
    mediaArticleIds: ['a-948', 'a-170', 'a-480']
  },
  'ashizuri-shimanto': {
    englishName: 'ASHIZURI-SHIMANTO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kochi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKochi */ .Z.i18n.webYadoPrefectureKochi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKochi */ .Z.i18n.webYadoAirportKochi()];
    },
    coordinates: {
      lat: 32.7253357,
      lng: 133.020959
    },
    mediaArticleIds: ['a-480']
  },
  matsumoto: {
    englishName: 'MATSUMOTO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.2380434,
      lng: 137.9719897
    },
    mediaArticleIds: []
  },
  shinshutakayama: {
    englishName: 'SHINSHUTAKAYAMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.6596022,
      lng: 138.4734426
    },
    mediaArticleIds: []
  },
  'hiroshima-miyajima': {
    englishName: 'HIROSHIMA-MIYAJIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hiroshima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHiroshima */ .Z.i18n.webYadoPrefectureHiroshima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHiroshima */ .Z.i18n.webYadoAirportHiroshima()];
    },
    coordinates: {
      lat: 34.2732114,
      lng: 132.3052488
    },
    mediaArticleIds: ['a-1552', 'a-1795', 'a-951', 'a-173', 'a-1897']
  },
  'yudanaka-shibu': {
    englishName: 'YUDANAKA-SHIBU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportToyama */ .Z.i18n.webYadoAirportToyama()];
    },
    coordinates: {
      lat: 36.7416383,
      lng: 138.4147279
    },
    mediaArticleIds: ['a-365', 'a-468']
  },
  hagi: {
    englishName: 'HAGI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamaguchi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamaguchi */ .Z.i18n.webYadoPrefectureYamaguchi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYamaguchiUbe */ .Z.i18n.webYadoAirportYamaguchiUbe(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHagiIwami */ .Z.i18n.webYadoAirportHagiIwami()];
    },
    coordinates: {
      lat: 34.4081121,
      lng: 131.3990499
    },
    mediaArticleIds: ['a-955', 'a-177']
  },
  yamaguchi: {
    englishName: 'YAMAGUCHI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamaguchi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamaguchi */ .Z.i18n.webYadoPrefectureYamaguchi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYamaguchiUbe */ .Z.i18n.webYadoAirportYamaguchiUbe(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHagiIwami */ .Z.i18n.webYadoAirportHagiIwami()];
    },
    coordinates: {
      lat: 34.2796769,
      lng: 131.5212742
    },
    mediaArticleIds: ['a-1410']
  },
  kirishima: {
    englishName: 'KIRISHIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kagoshima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKagoshima */ .Z.i18n.webYadoPrefectureKagoshima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKagoshima */ .Z.i18n.webYadoAirportKagoshima(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 31.7407317,
      lng: 130.7633282
    },
    mediaArticleIds: ['a-330']
  },
  'towadako-hachimantai': {
    englishName: 'TOWADAKO-HACHIMANTAI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'aomori',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureAomori */ .Z.i18n.webYadoPrefectureAomori()
      }, {
        prefectureId: 'akita',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureAkita */ .Z.i18n.webYadoPrefectureAkita()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportAomori */ .Z.i18n.webYadoAirportAomori()];
    },
    coordinates: {
      lat: 40.464869,
      lng: 140.8772428
    },
    mediaArticleIds: ['a-641', 'a-482']
  },
  tokurakamiyamada: {
    englishName: 'TOKURAKAMIYAMADA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.4810004,
      lng: 138.1431305
    },
    mediaArticleIds: ['a-755']
  },
  suwako: {
    englishName: 'SUWAKO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.0492617,
      lng: 138.0853146
    },
    mediaArticleIds: []
  },
  'tateshina-shirakabako': {
    englishName: 'TATESHINA-SHIRAKABAKO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.1054327,
      lng: 138.235759
    },
    mediaArticleIds: []
  },
  isawa: {
    englishName: 'ISAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamanashi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamanashi */ .Z.i18n.webYadoPrefectureYamanashi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 35.6576646,
      lng: 138.635273
    },
    mediaArticleIds: ['a-362']
  },
  awajishima: {
    englishName: 'AWAJISHIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hyogo',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHyogo */ .Z.i18n.webYadoPrefectureHyogo()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.3257122,
      lng: 134.813111
    },
    mediaArticleIds: ['a-953', 'a-891', 'a-175']
  },
  'nyuto-tazawako': {
    englishName: 'NYUTO-TAZAWAKO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'akita',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureAkita */ .Z.i18n.webYadoPrefectureAkita()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYamagata */ .Z.i18n.webYadoAirportYamagata(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 39.7247761,
      lng: 140.6463759
    },
    mediaArticleIds: ['a-970', 'a-190', 'a-1528', 'a-1530']
  },
  'miyagi-zao': {
    englishName: 'MIYAGI-ZAO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'miyagi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureMiyagi */ .Z.i18n.webYadoPrefectureMiyagi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai()];
    },
    coordinates: {
      lat: 38.1121948,
      lng: 140.5310379
    },
    mediaArticleIds: ['a-1']
  },
  'sapporo-jozankei': {
    englishName: 'SAPPORO-JOZANKEI',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtJozankei */ .Z.i18n.pjtJozankei,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShinChitose */ .Z.i18n.webYadoAirportShinChitose()];
    },
    coordinates: {
      lat: 42.9637771,
      lng: 141.1629933
    },
    mediaArticleIds: ['a-959', 'a-546', 'a-466', 'a-459'],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtJozankeiAccess */ .Z.i18n.pjtJozankeiAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaSapporoJozankei */ .Z.assets.images.pjtAreaSapporoJozankei
  },
  noboribetsu: {
    englishName: 'NOBORIBETSU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShinChitose */ .Z.i18n.webYadoAirportShinChitose()];
    },
    coordinates: {
      lat: 42.504748,
      lng: 141.1455953
    },
    mediaArticleIds: ['a-973', 'a-960', 'a-182']
  },
  'hakodate-yunokawa': {
    englishName: 'HAKODATE-YUNOKAWA',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtYunokawa */ .Z.i18n.pjtYunokawa,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHakodate */ .Z.i18n.webYadoAirportHakodate()];
    },
    coordinates: {
      lat: 41.780011,
      lng: 140.7851319
    },
    mediaArticleIds: ['a-974', 'a-963', 'a-617', 'a-183'],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtYunokawaAccess */ .Z.i18n.pjtYunokawaAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaHakodateYunokawa */ .Z.assets.images.pjtAreaHakodateYunokawa
  },
  toyako: {
    englishName: 'TOYAKO',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtToya */ .Z.i18n.pjtToya,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShinChitose */ .Z.i18n.webYadoAirportShinChitose()];
    },
    coordinates: {
      lat: 42.5639776,
      lng: 140.8402841
    },
    mediaArticleIds: ['a-1289', 'a-1067', 'a-964', 'a-184'],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtJozankeiAccess */ .Z.i18n.pjtJozankeiAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaToyako */ .Z.assets.images.pjtAreaToyako
  },
  'madarao-nojiriko': {
    englishName: 'MADARAO-NOJIRIKO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.8560152,
      lng: 138.336425
    },
    mediaArticleIds: []
  },
  'kamikochi-norikura': {
    englishName: 'KAMIKOCHI-NORIKURA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.2513203,
      lng: 137.653235
    },
    mediaArticleIds: ['a-1049', 'a-1024', 'a-614']
  },
  'bessho-kakeyu': {
    englishName: 'UEDA-BESSHO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.3442648,
      lng: 138.1448904
    },
    mediaArticleIds: ['a-620']
  },
  nozawa: {
    englishName: 'NOZAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.9228462,
      lng: 138.4405097
    },
    mediaArticleIds: ['a-364', 'a-1211']
  },
  ibusuki: {
    englishName: 'IBUSUKI',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtIbusuki */ .Z.i18n.pjtIbusuki,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kagoshima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKagoshima */ .Z.i18n.webYadoPrefectureKagoshima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKagoshima */ .Z.i18n.webYadoAirportKagoshima(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 31.2230658,
      lng: 130.6554239
    },
    mediaArticleIds: ['a-331', 'a-460', 'a-597'],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtIbusukiAccess */ .Z.i18n.pjtIbusukiAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaIbusuki */ .Z.assets.images.pjtAreaIbusuki
  },
  hitoyoshi: {
    englishName: 'HITOYOSHI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kumamoto',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKumamoto */ .Z.i18n.webYadoPrefectureKumamoto()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKagoshima */ .Z.i18n.webYadoAirportKagoshima(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 32.2147467,
      lng: 130.7514941
    },
    mediaArticleIds: ['a-626', 'a-477']
  },
  'oze-oigami': {
    englishName: 'OZE-OIGAMI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gunma',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGunma */ .Z.i18n.webYadoPrefectureGunma()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.952557,
      lng: 139.3018759
    },
    mediaArticleIds: []
  },
  'otaru-asarigawa': {
    englishName: 'OTARU-ASARIGAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShinChitose */ .Z.i18n.webYadoAirportShinChitose()];
    },
    coordinates: {
      lat: 43.1231427,
      lng: 141.0436935
    },
    mediaArticleIds: ['a-1046', 'a-860', 'a-638', 'a-818', 'a-593']
  },
  naruko: {
    englishName: 'NARUKO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'miyagi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureMiyagi */ .Z.i18n.webYadoPrefectureMiyagi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYamagata */ .Z.i18n.webYadoAirportYamagata()];
    },
    coordinates: {
      lat: 38.7432721,
      lng: 140.7161541
    },
    mediaArticleIds: ['a-360', 'a-474']
  },
  yubara: {
    englishName: 'YUBARA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'okayama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOkayama */ .Z.i18n.webYadoPrefectureOkayama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYonago */ .Z.i18n.webYadoAirportYonago()];
    },
    coordinates: {
      lat: 35.2011368,
      lng: 133.7324155
    },
    mediaArticleIds: ['a-610', 'a-954', 'a-464']
  },
  awara: {
    englishName: 'AWARA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'fukui',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureFukui */ .Z.i18n.webYadoPrefectureFukui()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKomatsu */ .Z.i18n.webYadoAirportKomatsu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.2250093,
      lng: 136.1942838
    },
    mediaArticleIds: ['a-957', 'a-179', 'a-1912']
  },
  ureshino: {
    englishName: 'URESHINO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'saga',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureSaga */ .Z.i18n.webYadoPrefectureSaga()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 33.0971632,
      lng: 129.9850342
    },
    mediaArticleIds: ['a-481', 'a-329', 'a-1173']
  },
  'asahikawa-sounkyo': {
    englishName: 'ASAHIKAWA-SOUNKYO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportAsahikawa */ .Z.i18n.webYadoAirportAsahikawa(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShinChitose */ .Z.i18n.webYadoAirportShinChitose()];
    },
    coordinates: {
      lat: 43.8486298,
      lng: 142.7674429
    },
    mediaArticleIds: ['a-2011', 'a-1059', 'a-1181', 'a-785', 'a-1537']
  },
  gero: {
    englishName: 'GERO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gifu',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGifu */ .Z.i18n.webYadoPrefectureGifu()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportToyama */ .Z.i18n.webYadoAirportToyama()];
    },
    coordinates: {
      lat: 35.8053621,
      lng: 137.2397778
    },
    mediaArticleIds: ['a-972', 'a-198', 'a-1412'],
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaGero */ .Z.assets.images.pjtAreaGero
  },
  'ise-shima-toba': {
    englishName: 'ISE-SHIMA-TOBA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'mie',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureMie */ .Z.i18n.webYadoPrefectureMie()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.4874863,
      lng: 136.7092639
    },
    mediaArticleIds: ['a-529']
  },
  'unzen-obama-shimabara': {
    englishName: 'UNZEN-OBAMA-SHIMABARA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagasaki',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagasaki */ .Z.i18n.webYadoPrefectureNagasaki()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNagasaki */ .Z.i18n.webYadoAirportNagasaki()];
    },
    coordinates: {
      lat: 32.7418986,
      lng: 130.2608768
    },
    mediaArticleIds: ['a-359', 'a-624', 'a-57']
  },
  kaike: {
    englishName: 'KAIKE',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'tottori',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureTottori */ .Z.i18n.webYadoPrefectureTottori()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYonago */ .Z.i18n.webYadoAirportYonago()];
    },
    coordinates: {
      lat: 35.4564861,
      lng: 133.3620475
    },
    mediaArticleIds: ['a-947', 'a-169', 'a-456']
  },
  unazuki: {
    englishName: 'UNAZUKI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'toyama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureToyama */ .Z.i18n.webYadoPrefectureToyama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.7319717,
      lng: 137.6232752
    },
    mediaArticleIds: ['a-958', 'a-180', 'a-1911', 'a-1541']
  },
  gifu: {
    englishName: 'GIFU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gifu',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGifu */ .Z.i18n.webYadoPrefectureGifu()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu()];
    },
    coordinates: {
      lat: 35.7437491,
      lng: 136.9805103
    },
    mediaArticleIds: ['a-1156']
  },
  'yumura-kasumi': {
    englishName: 'YUMURA-KASUMI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hyogo',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHyogo */ .Z.i18n.webYadoPrefectureHyogo()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 35.5553173,
      lng: 134.4889583
    },
    mediaArticleIds: ['a-618', 'a-469']
  },
  'sasebo-iki-hirado': {
    englishName: 'SASEBO-IKI-HIRADO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagasaki',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagasaki */ .Z.i18n.webYadoPrefectureNagasaki()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 33.1804356,
      lng: 129.7157996
    },
    mediaArticleIds: ['a-387', 'a-1233']
  },
  yunogo: {
    englishName: 'YUNOGO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'okayama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOkayama */ .Z.i18n.webYadoPrefectureOkayama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama()];
    },
    coordinates: {
      lat: 34.9939411,
      lng: 134.1374391
    },
    mediaArticleIds: ['a-954', 'a-176', 'a-805', 'a-464']
  },
  minakami: {
    englishName: 'MINAKAMI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gunma',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGunma */ .Z.i18n.webYadoPrefectureGunma()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.7762027,
      lng: 138.9670274
    },
    mediaArticleIds: []
  },
  tamatsukuri: {
    englishName: 'TAMATSUKURI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shimane',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShimane */ .Z.i18n.webYadoPrefectureShimane()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYonago */ .Z.i18n.webYadoAirportYonago()];
    },
    coordinates: {
      lat: 35.430877,
      lng: 133.011819
    },
    mediaArticleIds: []
  },
  nagoya: {
    englishName: 'NAGOYA-AREA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'aichi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureAichi */ .Z.i18n.webYadoPrefectureAichi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu()];
    },
    coordinates: {
      lat: 35.0182505,
      lng: 137.2923893
    },
    mediaArticleIds: []
  },
  shima: {
    englishName: 'SHIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gunma',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGunma */ .Z.i18n.webYadoPrefectureGunma()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.6832232,
      lng: 138.7769096
    },
    mediaArticleIds: []
  },
  kaga: {
    englishName: 'KAGA',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtKaga */ .Z.i18n.pjtKaga,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'ishikawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureIshikawa */ .Z.i18n.webYadoPrefectureIshikawa()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKomatsu */ .Z.i18n.webYadoAirportKomatsu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.3205504,
      lng: 136.3503149
    },
    mediaArticleIds: [],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtKagaAccess */ .Z.i18n.pjtKagaAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaKaga */ .Z.assets.images.pjtAreaKaga
  },
  wakura: {
    englishName: 'WAKURA',
    pjtName: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtWakura */ .Z.i18n.pjtWakura,
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'ishikawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureIshikawa */ .Z.i18n.webYadoPrefectureIshikawa()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKomatsu */ .Z.i18n.webYadoAirportKomatsu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 37.074977,
      lng: 136.925587
    },
    mediaArticleIds: [],
    access: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.pjtWakuraAccess */ .Z.i18n.pjtWakuraAccess,
    pjtThumbnail: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.pjtAreaWakura */ .Z.assets.images.pjtAreaWakura
  },
  'kyoto-city': {
    englishName: 'KYOTO-CITY',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kyoto',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKyoto */ .Z.i18n.webYadoPrefectureKyoto()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.985849,
      lng: 135.7587667
    },
    mediaArticleIds: []
  },
  'kyoto-amanohashidate': {
    englishName: 'KYOTO-AMANOHASHIDATE',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kyoto',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKyoto */ .Z.i18n.webYadoPrefectureKyoto()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 35.5698022,
      lng: 135.1918204
    },
    mediaArticleIds: []
  },
  'tsuyama-hiruzen': {
    englishName: 'TSUYAMA-HIRUZEN',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'okayama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOkayama */ .Z.i18n.webYadoPrefectureOkayama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama()];
    },
    coordinates: {
      lat: 35.2957595,
      lng: 133.6783022
    },
    mediaArticleIds: []
  },
  'isobe-tomioka': {
    englishName: 'ISOBE-TOMIOKA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gunma',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGunma */ .Z.i18n.webYadoPrefectureGunma()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.3003165,
      lng: 138.8467266
    },
    mediaArticleIds: []
  },
  ginzan: {
    englishName: 'GINZAN',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamagata',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamagata */ .Z.i18n.webYadoPrefectureYamagata()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYamagata */ .Z.i18n.webYadoAirportYamagata()];
    },
    coordinates: {
      lat: 38.570404,
      lng: 140.5304678
    },
    mediaArticleIds: []
  },
  hawai: {
    englishName: 'HAWAI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'tottori',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureTottori */ .Z.i18n.webYadoPrefectureTottori()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYonago */ .Z.i18n.webYadoAirportYonago()];
    },
    coordinates: {
      lat: 35.4778718,
      lng: 133.8828418
    },
    mediaArticleIds: []
  },
  kitayuzawa: {
    englishName: 'KITAYUZAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShinChitose */ .Z.i18n.webYadoAirportShinChitose()];
    },
    coordinates: {
      lat: 42.6203559,
      lng: 141.0233075
    },
    mediaArticleIds: []
  },
  'kagoshima-centralarea': {
    englishName: 'KAGOSHIMA CENTRAL AREA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kagoshima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKagoshima */ .Z.i18n.webYadoPrefectureKagoshima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKagoshima */ .Z.i18n.webYadoAirportKagoshima(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 31.5968539,
      lng: 130.5571392
    },
    mediaArticleIds: []
  },
  'tokachigawa-obihiro': {
    englishName: 'TOKACHIGAWA-OBIHIRO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShinChitose */ .Z.i18n.webYadoAirportShinChitose()];
    },
    coordinates: {
      lat: 42.9342824,
      lng: 143.2966072
    },
    mediaArticleIds: []
  },
  takamatsu: {
    englishName: 'TAKAMATSU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kagawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKagawa */ .Z.i18n.webYadoPrefectureKagawa()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTakamatsu */ .Z.i18n.webYadoAirportTakamatsu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama()];
    },
    coordinates: {
      lat: 34.3506795,
      lng: 134.0469281
    },
    mediaArticleIds: []
  },
  yamanashi: {
    englishName: 'YAMANASHI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamanashi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamanashi */ .Z.i18n.webYadoPrefectureYamanashi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 35.6635113,
      lng: 138.6388879
    },
    mediaArticleIds: []
  },
  'hakuba-omachi-azumino': {
    englishName: 'HAKUBA-OMACHI-AZUMINO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.6981614,
      lng: 137.8619333
    },
    mediaArticleIds: []
  },
  kagawa: {
    englishName: 'KAGAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kagawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKagawa */ .Z.i18n.webYadoPrefectureKagawa()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportMatsuyama */ .Z.i18n.webYadoAirportMatsuyama(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTakamatsu */ .Z.i18n.webYadoAirportTakamatsu()];
    },
    coordinates: {
      lat: 34.2225915,
      lng: 134.0199152
    },
    mediaArticleIds: []
  },
  'okayama-kurashiki': {
    englishName: 'OKAYAMA-KURASHIKI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'okayama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOkayama */ .Z.i18n.webYadoPrefectureOkayama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.5849782,
      lng: 133.7719812
    },
    mediaArticleIds: []
  },
  'kochi-city': {
    englishName: 'AROUND KOCHI-CITY',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kochi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKochi */ .Z.i18n.webYadoPrefectureKochi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportTakamatsu */ .Z.i18n.webYadoAirportTakamatsu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama()];
    },
    coordinates: {
      lat: 33.5672271,
      lng: 133.5436452
    },
    mediaArticleIds: []
  },
  tsukioka: {
    englishName: 'TSUKIOKA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'niigata',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNigata */ .Z.i18n.webYadoPrefectureNigata()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNigata */ .Z.i18n.webYadoAirportNigata()];
    },
    coordinates: {
      lat: 37.8810316,
      lng: 139.3108071
    },
    mediaArticleIds: []
  },
  shimonoseki: {
    englishName: 'SHIMONOSEKI TSUNOSHIMA KAWADANA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamaguchi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamaguchi */ .Z.i18n.webYadoPrefectureYamaguchi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 34.1463048,
      lng: 130.9223266
    },
    mediaArticleIds: []
  },
  'iizaka-tsuchiyu-bandaiatami': {
    englishName: 'IIZAKA TSUCHIYU BANDAIATAMI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'fukushima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureFukushima */ .Z.i18n.webYadoPrefectureFukushima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 37.8302806,
      lng: 140.4546831
    },
    mediaArticleIds: []
  },
  imabari: {
    englishName: 'IMABARI SHIMANAMI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'ehime',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureEhime */ .Z.i18n.webYadoPrefectureEhime()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOkayama */ .Z.i18n.webYadoAirportOkayama(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportMatsuyama */ .Z.i18n.webYadoAirportMatsuyama()];
    },
    coordinates: {
      lat: 34.0643389,
      lng: 132.9937828
    },
    mediaArticleIds: []
  },
  dorogawa: {
    englishName: 'DOROGAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nara',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNara */ .Z.i18n.webYadoPrefectureNara()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.26349,
      lng: 135.8769242
    },
    mediaArticleIds: []
  },
  'kumano-hongu': {
    englishName: 'KUMANO HONGU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'wakayama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureWakayama */ .Z.i18n.webYadoPrefectureWakayama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 33.8383012,
      lng: 135.7756875
    },
    mediaArticleIds: []
  },
  kanazawa: {
    englishName: 'AROUND KANAZAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'ishikawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureIshikawa */ .Z.i18n.webYadoPrefectureIshikawa()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKomatsu */ .Z.i18n.webYadoAirportKomatsu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.5780443,
      lng: 136.6481714
    },
    mediaArticleIds: []
  },
  katsuura: {
    englishName: 'KATSUURA AREA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'wakayama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureWakayama */ .Z.i18n.webYadoPrefectureWakayama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 35.2031888,
      lng: 140.2745509
    },
    mediaArticleIds: []
  },
  akayu: {
    englishName: 'AKAYU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamagata',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamagata */ .Z.i18n.webYadoPrefectureYamagata()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai()];
    },
    coordinates: {
      lat: 38.047135,
      lng: 140.149239
    },
    mediaArticleIds: []
  },
  'hamamatsu-hamanako': {
    englishName: 'HAMAMATSU-HAMANAKO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shizuoka',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShizuoka */ .Z.i18n.webYadoPrefectureShizuoka()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.703476,
      lng: 137.7348916
    },
    mediaArticleIds: []
  },
  'shizuoka-yaizu': {
    englishName: 'SHIZUOKA-YAIZU',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shizuoka',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShizuoka */ .Z.i18n.webYadoPrefectureShizuoka()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.872459,
      lng: 138.3185038
    },
    mediaArticleIds: []
  },
  shigakogen: {
    englishName: 'SHIGAKOGEN',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita()];
    },
    coordinates: {
      lat: 36.7195034,
      lng: 138.4896635
    },
    mediaArticleIds: []
  },
  niigata: {
    englishName: 'NIIGATA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'niigata',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNigata */ .Z.i18n.webYadoPrefectureNigata()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNigata */ .Z.i18n.webYadoAirportNigata()];
    },
    coordinates: {
      lat: 37.9375504,
      lng: 139.0609858
    },
    mediaArticleIds: []
  },
  hokkaido: {
    englishName: 'HOKKAIDO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hokkaido',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHokkaido */ .Z.i18n.webYadoPrefectureHokkaido()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportShinChitose */ .Z.i18n.webYadoAirportShinChitose(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportAsahikawa */ .Z.i18n.webYadoAirportAsahikawa()];
    },
    coordinates: {
      lat: 43.288853,
      lng: 142.60581
    },
    mediaArticleIds: []
  },
  aomori: {
    englishName: 'AOMORI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'aomori',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureAomori */ .Z.i18n.webYadoPrefectureAomori()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportAomori */ .Z.i18n.webYadoAirportAomori()];
    },
    coordinates: {
      lat: 40.824868,
      lng: 140.745783
    },
    mediaArticleIds: []
  },
  iwate: {
    englishName: 'IWATE',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'iwate',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureIwate */ .Z.i18n.webYadoPrefectureIwate()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHanamaki */ .Z.i18n.webYadoAirportHanamaki()];
    },
    coordinates: {
      lat: 39.979891,
      lng: 141.209038
    },
    mediaArticleIds: []
  },
  miyagi: {
    englishName: 'MIYAGI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'miyagi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureMiyagi */ .Z.i18n.webYadoPrefectureMiyagi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportSendai */ .Z.i18n.webYadoAirportSendai()];
    },
    coordinates: {
      lat: 38.7041,
      lng: 140.791916
    },
    mediaArticleIds: []
  },
  akita: {
    englishName: 'AKITA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'akita',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureAkita */ .Z.i18n.webYadoPrefectureAkita()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.commonAirportAxt */ .Z.i18n.commonAirportAxt()];
    },
    coordinates: {
      lat: 39.723595,
      lng: 140.116491
    },
    mediaArticleIds: []
  },
  yamagata: {
    englishName: 'YAMAGATA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'yamagata',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureYamagata */ .Z.i18n.webYadoPrefectureYamagata()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportYamagata */ .Z.i18n.webYadoAirportYamagata()];
    },
    coordinates: {
      lat: 38.262766,
      lng: 140.339832
    },
    mediaArticleIds: []
  },
  fukushima: {
    englishName: 'FUKUSHIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'fukushima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureFukushima */ .Z.i18n.webYadoPrefectureFukushima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukushima */ .Z.i18n.webYadoAirportFukushima()];
    },
    coordinates: {
      lat: 37.769538,
      lng: 140.470375
    },
    mediaArticleIds: []
  },
  ibaraki: {
    englishName: 'IBARAKI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'ibaraki',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureIbaraki */ .Z.i18n.webYadoPrefectureIbaraki()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda()];
    },
    coordinates: {
      lat: 36.693768,
      lng: 140.443485
    },
    mediaArticleIds: []
  },
  tochigi: {
    englishName: 'TOCHIGI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'tochigi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureTochigi */ .Z.i18n.webYadoPrefectureTochigi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda()];
    },
    coordinates: {
      lat: 36.939479,
      lng: 139.877751
    },
    mediaArticleIds: []
  },
  gunma: {
    englishName: 'GUNMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'gunma',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureGunma */ .Z.i18n.webYadoPrefectureGunma()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda()];
    },
    coordinates: {
      lat: 36.674567,
      lng: 138.950746
    },
    mediaArticleIds: []
  },
  saitama: {
    englishName: 'SAITAMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'saitama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureSaitama */ .Z.i18n.webYadoPrefectureSaitama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda()];
    },
    coordinates: {
      lat: 35.907487,
      lng: 139.64892
    },
    mediaArticleIds: []
  },
  chiba: {
    englishName: 'CHIBA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'chiba',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureChiba */ .Z.i18n.webYadoPrefectureChiba()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda()];
    },
    coordinates: {
      lat: 35.618796,
      lng: 40.100926
    },
    mediaArticleIds: []
  },
  tokyo: {
    englishName: 'TOKYO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'tokyo',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureTokyo */ .Z.i18n.webYadoPrefectureTokyo()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda()];
    },
    coordinates: {
      lat: 35.783297,
      lng: 139.763246
    },
    mediaArticleIds: []
  },
  kanagawa: {
    englishName: 'KANAGAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kanagawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKanagawa */ .Z.i18n.webYadoPrefectureKanagawa()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda()];
    },
    coordinates: {
      lat: 35.420445,
      lng: 139.265844
    },
    mediaArticleIds: []
  },
  toyama: {
    englishName: 'TOYAMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'toyama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureToyama */ .Z.i18n.webYadoPrefectureToyama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportToyama */ .Z.i18n.webYadoAirportToyama()];
    },
    coordinates: {
      lat: 36.713941,
      lng: 137.218414
    },
    mediaArticleIds: []
  },
  ishikawa: {
    englishName: 'ISHIKAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'ishikawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureIshikawa */ .Z.i18n.webYadoPrefectureIshikawa()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKomatsu */ .Z.i18n.webYadoAirportKomatsu()];
    },
    coordinates: {
      lat: 36.329348,
      lng: 136.556204
    },
    mediaArticleIds: []
  },
  fukui: {
    englishName: 'FUKUI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'fukui',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureFukui */ .Z.i18n.webYadoPrefectureFukui()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKomatsu */ .Z.i18n.webYadoAirportKomatsu()];
    },
    coordinates: {
      lat: 36.069879,
      lng: 136.220347
    },
    mediaArticleIds: []
  },
  nagano: {
    englishName: 'NAGANO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagano',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagano */ .Z.i18n.webYadoPrefectureNagano()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda()];
    },
    coordinates: {
      lat: 36.662112,
      lng: 138.192725
    },
    mediaArticleIds: []
  },
  shizuoka: {
    englishName: 'SHIZUOKA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shizuoka',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShizuoka */ .Z.i18n.webYadoPrefectureShizuoka()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNarita */ .Z.i18n.webYadoAirportNarita(), _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHaneda */ .Z.i18n.webYadoAirportHaneda()];
    },
    coordinates: {
      lat: 35.005296,
      lng: 138.369914
    },
    mediaArticleIds: []
  },
  aichi: {
    englishName: 'AICHI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'aichi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureAichi */ .Z.i18n.webYadoPrefectureAichi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu()];
    },
    coordinates: {
      lat: 35.089571,
      lng: 137.306363
    },
    mediaArticleIds: []
  },
  mie: {
    englishName: 'MIE',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'mie',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureMie */ .Z.i18n.webYadoPrefectureMie()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu()];
    },
    coordinates: {
      lat: 34.410767,
      lng: 136.584171
    },
    mediaArticleIds: []
  },
  shiga: {
    englishName: 'SHIGA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shiga',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShiga */ .Z.i18n.webYadoPrefectureShiga()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportChubu */ .Z.i18n.webYadoAirportChubu()];
    },
    coordinates: {
      lat: 35.162318,
      lng: 36.150249
    },
    mediaArticleIds: []
  },
  kyoto: {
    englishName: 'KYOTO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kyoto',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKyoto */ .Z.i18n.webYadoPrefectureKyoto()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 35.010063,
      lng: 135.75588
    },
    mediaArticleIds: []
  },
  osaka: {
    englishName: 'OSAKA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'osaka',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOsaka */ .Z.i18n.webYadoPrefectureOsaka()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.671923,
      lng: 135.498049
    },
    mediaArticleIds: []
  },
  hyogo: {
    englishName: 'HYOGO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hyogo',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHyogo */ .Z.i18n.webYadoPrefectureHyogo()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 35.096801,
      lng: 134.897972
    },
    mediaArticleIds: []
  },
  nara: {
    englishName: 'NARA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nara',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNara */ .Z.i18n.webYadoPrefectureNara()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.69452,
      lng: 135.796609
    },
    mediaArticleIds: []
  },
  wakayama: {
    englishName: 'WAKAYAMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'wakayama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureWakayama */ .Z.i18n.webYadoPrefectureWakayama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.237393,
      lng: 135.165099
    },
    mediaArticleIds: []
  },
  tottori: {
    englishName: 'TOTTORI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'tottori',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureTottori */ .Z.i18n.webYadoPrefectureTottori()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 35.511232,
      lng: 134.242136
    },
    mediaArticleIds: []
  },
  shimane: {
    englishName: 'SHIMANE',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'shimane',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureShimane */ .Z.i18n.webYadoPrefectureShimane()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHiroshima */ .Z.i18n.webYadoAirportHiroshima()];
    },
    coordinates: {
      lat: 35.066373,
      lng: 132.588619
    },
    mediaArticleIds: []
  },
  okayama: {
    englishName: 'OKAYAMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'okayama',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOkayama */ .Z.i18n.webYadoPrefectureOkayama()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHiroshima */ .Z.i18n.webYadoAirportHiroshima()];
    },
    coordinates: {
      lat: 34.651942,
      lng: 133.90642
    },
    mediaArticleIds: []
  },
  hiroshima: {
    englishName: 'HIROSHIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'hiroshima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureHiroshima */ .Z.i18n.webYadoPrefectureHiroshima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportHiroshima */ .Z.i18n.webYadoAirportHiroshima()];
    },
    coordinates: {
      lat: 34.383891,
      lng: 132.464751
    },
    mediaArticleIds: []
  },
  tokushima: {
    englishName: 'TOKUSHIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'tokushima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureTokushima */ .Z.i18n.webYadoPrefectureTokushima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKansaiKokusai */ .Z.i18n.webYadoAirportKansaiKokusai()];
    },
    coordinates: {
      lat: 34.074909,
      lng: 134.55376
    },
    mediaArticleIds: []
  },
  ehime: {
    englishName: 'EHIME',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'ehime',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureEhime */ .Z.i18n.webYadoPrefectureEhime()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportMatsuyama */ .Z.i18n.webYadoAirportMatsuyama()];
    },
    coordinates: {
      lat: 33.692151,
      lng: 132.844039
    },
    mediaArticleIds: []
  },
  kochi: {
    englishName: 'KOCHI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kochi',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKochi */ .Z.i18n.webYadoPrefectureKochi()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKochi */ .Z.i18n.webYadoAirportKochi()];
    },
    coordinates: {
      lat: 33.566372,
      lng: 133.529092
    },
    mediaArticleIds: []
  },
  fukuoka: {
    englishName: 'FUKUOKA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'fukuoka',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureFukuoka */ .Z.i18n.webYadoPrefectureFukuoka()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 33.595789,
      lng: 130.390245
    },
    mediaArticleIds: []
  },
  saga: {
    englishName: 'SAGA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'saga',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureSaga */ .Z.i18n.webYadoPrefectureSaga()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportFukuoka */ .Z.i18n.webYadoAirportFukuoka()];
    },
    coordinates: {
      lat: 33.267522,
      lng: 130.303177
    },
    mediaArticleIds: []
  },
  nagasaki: {
    englishName: 'NAGASAKI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'nagasaki',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureNagasaki */ .Z.i18n.webYadoPrefectureNagasaki()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNagasaki */ .Z.i18n.webYadoAirportNagasaki()];
    },
    coordinates: {
      lat: 32.754706,
      lng: 129.875796
    },
    mediaArticleIds: []
  },
  kumamoto: {
    englishName: 'KUMAMOTO',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kumamoto',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKumamoto */ .Z.i18n.webYadoPrefectureKumamoto()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKumamoto */ .Z.i18n.webYadoAirportKumamoto()];
    },
    coordinates: {
      lat: 32.801486,
      lng: 130.711204
    },
    mediaArticleIds: []
  },
  oita: {
    englishName: 'OITA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'oita',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOita */ .Z.i18n.webYadoPrefectureOita()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportOita */ .Z.i18n.webYadoAirportOita()];
    },
    coordinates: {
      lat: 33.249813,
      lng: 131.609069
    },
    mediaArticleIds: []
  },
  miyazaki: {
    englishName: 'MIYAZAKI',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'miyazaki',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureMiyazaki */ .Z.i18n.webYadoPrefectureMiyazaki()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportMiyazaki */ .Z.i18n.webYadoAirportMiyazaki()];
    },
    coordinates: {
      lat: 31.905011,
      lng: 131.416755
    },
    mediaArticleIds: []
  },
  kagoshima: {
    englishName: 'KAGOSHIMA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'kagoshima',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureKagoshima */ .Z.i18n.webYadoPrefectureKagoshima()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportKagoshima */ .Z.i18n.webYadoAirportKagoshima()];
    },
    coordinates: {
      lat: 31.597396,
      lng: 130.55809
    },
    mediaArticleIds: []
  },
  okinawa: {
    englishName: 'OKINAWA',
    getPrefectures: function getPrefectures() {
      return [{
        prefectureId: 'okinawa',
        label: _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoPrefectureOkinawa */ .Z.i18n.webYadoPrefectureOkinawa()
      }];
    },
    getAirports: function getAirports() {
      return [_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].i18n.webYadoAirportNaha */ .Z.i18n.webYadoAirportNaha()];
    },
    coordinates: {
      lat: 26.351877,
      lng: 127.80526
    },
    mediaArticleIds: []
  }
};
var AREA_SLUGS = ['hakone-yugawara', 'yugawara', 'nikko-kinugawa', 'hanamaki', 'kusatsu', 'ikaho', 'shiretoko', 'izu', 'nankishirahama', 'arima', 'kinosaki', 'misasa', 'dogo', 'beppu', 'yufuin', 'kurokawa', 'shodoshima', 'akiu', 'tendo', 'zao', 'echigoyuzawa', 'yuda', 'fuji', 'aizu', 'atami', 'ogoto', 'hida-takayama', 'kotohira', 'nagatoyumoto-yuyawan', 'oboke-iya', 'ashizuri-shimanto', 'matsumoto', 'shinshutakayama', 'hiroshima-miyajima', 'yudanaka-shibu', 'hagi', 'yamaguchi', 'kirishima', 'towadako-hachimantai', 'tokurakamiyamada', 'suwako', 'tateshina-shirakabako', 'isawa', 'awajishima', 'nyuto-tazawako', 'miyagi-zao', 'sapporo-jozankei', 'noboribetsu', 'hakodate-yunokawa', 'toyako', 'madarao-nojiriko', 'kamikochi-norikura', 'bessho-kakeyu', 'nozawa', 'ibusuki', 'hitoyoshi', 'oze-oigami', 'otaru-asarigawa', 'naruko', 'yubara', 'awara', 'ureshino', 'asahikawa-sounkyo', 'gero', 'ise-shima-toba', 'unzen-obama-shimabara', 'kaike', 'unazuki', 'gifu', 'yumura-kasumi', 'sasebo-iki-hirado', 'yunogo', 'minakami', 'tamatsukuri', 'nagoya', 'shima', 'kaga', 'wakura', 'kyoto-city', 'kyoto-amanohashidate', 'tsuyama-hiruzen', 'isobe-tomioka', 'ginzan', 'hawai', 'kitayuzawa', 'kagoshima-centralarea', 'tokachigawa-obihiro', 'takamatsu', 'yamanashi', 'hakuba-omachi-azumino', 'kagawa', 'okayama-kurashiki', 'kochi-city', 'tsukioka', 'shimonoseki', 'iizaka-tsuchiyu-bandaiatami', 'imabari', 'dorogawa', 'kumano-hongu', 'kanazawa', 'katsuura', 'akayu', 'hamamatsu-hamanako', 'shizuoka-yaizu', 'shigakogen', 'niigata', 'hokkaido', 'aomori', 'iwate', 'miyagi', 'akita', 'yamagata', 'fukushima', 'ibaraki', 'tochigi', 'gunma', 'saitama', 'chiba', 'tokyo', 'kanagawa', 'toyama', 'ishikawa', 'fukui', 'nagano', 'shizuoka', 'aichi', 'mie', 'shiga', 'kyoto', 'osaka', 'hyogo', 'nara', 'wakayama', 'tottori', 'shimane', 'okayama', 'hiroshima', 'tokushima', 'ehime', 'kochi', 'fukuoka', 'saga', 'nagasaki', 'kumamoto', 'oita', 'miyazaki', 'kagoshima', 'okinawa'].concat((0,_tmp_build_c0c8f40b_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_constants_ENV__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENVIRONMENT */ .Z.ENVIRONMENT !== 'production' ? ['wamazing'] : []));
var POPULAR_AREA_SLUGS = (/* unused pure expression or super */ null && ([// モデルエリアC
'nikko-kinugawa', 'kinosaki', 'misasa', 'wakura', // モデルエリアB
'hakodate-yunokawa', 'yudanaka-shibu', 'hida-takayama', // モデルエリアA
'arima', 'kurokawa', 'yufuin', 'beppu']));
var AREA_COUNT = AREA_SLUGS.length;
var AreaVariation;

(function (AreaVariation) {
  AreaVariation["Regions"] = "regions";
  AreaVariation["Prefectures"] = "prefectures";
  AreaVariation["Areas"] = "areas";
})(AreaVariation || (AreaVariation = {}));

function transferCanonicalUrl(url) {
  if (url.includes('hokkaido') && url.includes(AreaVariation.Prefectures)) {
    return url.replace(AreaVariation.Prefectures, AreaVariation.Regions);
  }

  return url;
}

function getOnsensExtraInfoWithFilter(_ref) {
  var originUrl = _ref.originUrl,
      filterConditionStore = _ref.filterConditionStore;
  var originCanonical = transferCanonicalUrl(originUrl);
  var originData = {
    canonical: originCanonical,
    getExtraDescription: null,
    getExtraTitle: null,
    getExtraH1: null
  };

  if (!filterConditionStore) {
    return originData;
  }

  var preferenceIds = filterConditionStore.filterCondition.preferenceIds;
  var hasTwoMeals = preferenceIds.includes('hasTwoMeals');
  var hasPrivateBaths = preferenceIds.includes('privateBaths');

  if (hasPrivateBaths && !hasTwoMeals) {
    return {
      canonical: "".concat(originCanonical, "?preferenceIds%5B0%5D=privateBaths"),
      getExtraDescription: _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"].yadosOnsenMetaExtraDescription */ .Z.yadosOnsenMetaExtraDescription,
      getExtraTitle: _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"].yadosOnsenTitle */ .Z.yadosOnsenTitle,
      getExtraH1: _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"].yadosOnsenH1 */ .Z.yadosOnsenH1
    };
  } else if (hasTwoMeals && !hasPrivateBaths) {
    return {
      canonical: "".concat(originCanonical, "?preferenceIds%5B0%5D=hasTwoMeals"),
      getExtraDescription: _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"].hasTwoMealsMetaExtraDescription */ .Z.hasTwoMealsMetaExtraDescription,
      getExtraTitle: _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"].hasTwoMealsTitle */ .Z.hasTwoMealsTitle,
      getExtraH1: _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"].hasTwoMealsH1 */ .Z.hasTwoMealsH1
    };
  }

  return originData;
}
function getOnsenAreaDetailBySlug(areaSlug) {
  if (!AREA_SLUGS.includes(areaSlug)) return null;

  var _getOnsenAreaObject = getOnsenAreaObject(areaSlug),
      englishName = _getOnsenAreaObject.englishName,
      coordinates = _getOnsenAreaObject.coordinates,
      mediaArticleIds = _getOnsenAreaObject.mediaArticleIds;

  return {
    id: areaSlug,
    localizedName: getTranslatedOnsenAreaName(areaSlug),
    englishName: englishName,
    description: getTranslatedOnsenAreaDescription(areaSlug),
    coordinates: coordinates,
    photo: getOnsenAreaCoverPhoto(areaSlug),
    mediaArticleIds: mediaArticleIds
  };
}
function getOnsenAreaLinkBySlug(areaSlug) {
  var detailPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _getOnsenAreaObject2 = getOnsenAreaObject(areaSlug),
      englishName = _getOnsenAreaObject2.englishName,
      getPrefectures = _getOnsenAreaObject2.getPrefectures,
      getAirports = _getOnsenAreaObject2.getAirports;

  return {
    localizedName: getTranslatedOnsenAreaName(areaSlug),
    englishName: englishName,
    prefectures: getPrefectures(),
    link: detailPage ? (0,_shared_utils_url_helper__WEBPACK_IMPORTED_MODULE_4__/* .createAreaDetailLink */ .yB)(areaSlug) : (0,_shared_utils_url_helper__WEBPACK_IMPORTED_MODULE_4__/* .createAreaYadoListLink */ .o$)(areaSlug),
    imagePath: getOnsenAreaThumbnail(areaSlug),
    airports: getAirports()
  };
}
function getOnsenAreaLinksBySlugs(areaSlugs) {
  var detailPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return areaSlugs.map(function (s) {
    return getOnsenAreaLinkBySlug(s, detailPage);
  });
}
function getOnsenAreaYadoListLinks() {
  return getOnsenAreaLinksBySlugs(AREA_SLUGS);
}
function getOnsenPopularAreaDetailLinks() {
  return getOnsenAreaLinksBySlugs(POPULAR_AREA_SLUGS, true);
}
function getOnsenAreaObject(areaSlug) {
  var areaObj = onsenAreaObjects[areaSlug];

  if (areaObj) {
    return areaObj;
  }

  reportOnsenAreaKeyNotDefinedError(areaSlug, 'jsObject');
  return {
    englishName: '',
    getPrefectures: function getPrefectures() {
      return [];
    },
    coordinates: {
      lat: 0,
      lng: 0
    },
    getAirports: function getAirports() {
      return [];
    },
    mediaArticleIds: []
  };
}
function getOnsenAreaThumbnail(areaSlug) {
  var key = "onsenYadoArea".concat((0,_legacy_shared_utils_string__WEBPACK_IMPORTED_MODULE_6__/* .kebabToHungarian */ .Y7)(areaSlug));
  return getImagePath(key);
}
function getOnsenAreaCoverPhoto(areaSlug) {
  var key = "onsenYadoAreaCover".concat((0,_legacy_shared_utils_string__WEBPACK_IMPORTED_MODULE_6__/* .kebabToHungarian */ .Y7)(areaSlug));
  return getImagePath(key);
}
function getTranslatedOnsenAreaName(areaSlug) {
  var key = "webYadoOnsenArea".concat((0,_legacy_shared_utils_string__WEBPACK_IMPORTED_MODULE_6__/* .kebabToHungarian */ .Y7)(areaSlug));
  if (!(key in _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)) return '';
  return _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key]();
}

function getTranslatedOnsenAreaDescription(areaSlug) {
  var key = "webYadoOnsenArea".concat((0,_legacy_shared_utils_string__WEBPACK_IMPORTED_MODULE_6__/* .kebabToHungarian */ .Y7)(areaSlug), "Description");

  try {
    if (!(key in _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)) return '';
    return _R_string_i18n__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key]();
  } catch (error) {
    console.warn("getTranslatedOnsenAreaDescription-".concat(areaSlug, ":"), error);
    return '';
  }
}

function getImagePath(key) {
  if (_R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images */ .Z.assets.images[key]) {
    return _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images */ .Z.assets.images[key];
  } // defaultのimageを当てる


  return _R__WEBPACK_IMPORTED_MODULE_0__/* ["default"].assets.images.onsenYadoAreaCoverDefault */ .Z.assets.images.onsenYadoAreaCoverDefault;
}

function reportOnsenAreaKeyNotDefinedError(key, type) {
  _models_trackings_SentryReporter__WEBPACK_IMPORTED_MODULE_3__/* ["default"].captureException */ .Z.captureException("".concat(key, " is not defined in ").concat(type, "!!"));
}

/***/ })

}]);